import { crsInstance } from '../api/Axios';
import { getLS } from '../storage/LocalStorage';
import { isProd, LS_CRS_UTM } from '../constants/variables';
import { TCRSActivityItem, TCRSData, TCRSParams } from '@/domain/CRS.domain';
import {
    createCRSCartItems,
    createCRSOrderItems,
    createUserInfoData,
    getUser,
    res400Error,
} from './crsCreators';
import { TOrderData } from '@/domain/Order.domain';
import { TCartItem } from '@/domain/Cart.domain';

const CRS_ENDPOINT = 'trackEvents';
const RESOURCE = isProd ? 'reservations/' : 'reservations-staging/';

export enum EVENT {
    attractions = 'attractions',
    productDetail = 'productDetail',
    wishListAdded = 'wishListAdded',
    wishListRemoved = 'wishListRemoved',
    checkoutContacts = 'checkoutContacts',
    checkoutPayment = 'checkoutPayment',
    pageView = 'pageView',
    promoCodeRequest = 'promoCodeRequest',
    subscribed = 'subscribed',
    purchase = 'purchase',
    updateCart = 'updateCart',
}

const sendPostEventCRS = (path: string, data: object) => {
    return crsInstance.post(path, data) as unknown as Promise<{
        status: number;
        data: object;
    }>;
};

/* CRS events */

export const trackCRS = (eventType: string, data: object, pathName?: string) => {
    const { email } = getUser();

    if (email) {
        return sendPostEventCRS(CRS_ENDPOINT, {
            eventType,
            resource: RESOURCE + pathName,
            user: {
                email,
            },
            data,
        });
    }
    return res400Error;
};

/* export const sendUserUpdateCRS = ({ email, dataFields }: { email: string; dataFields: object }) => {
    if (Object.keys(dataFields).length !== 0) {
        const userInfo = createUserInfoData();

        return sendPostEventCRS(CRS_ENDPOINT, {
            eventType: 'user',
            user: {
                email,
                ...userInfo,
            },
            dataFields,
        });
    }
    return res400Error;
}; */

export const trackUpadteCartCRS = (data: TCRSData, partnerSlug: string) => {
    const { email } = getUser();

    if (email) {
        return sendPostEventCRS(CRS_ENDPOINT, {
            eventType: EVENT.updateCart,
            resource: RESOURCE + partnerSlug,
            user: { email },
            data,
        });
    }
    return res400Error;
};

export const trackProductDetailCRS = (data: TCRSActivityItem) => {
    const { email } = getUser();

    if (email) {
        return sendPostEventCRS(CRS_ENDPOINT, {
            eventType: EVENT.productDetail,
            resource: RESOURCE + data.brand,
            user: { email },
            data,
        });
    }
    return res400Error;
};

export const trackCheckoutPaymentPageCRS = (cartItems: TCartItem[], partnerSlug: string) => {
    const userInfo = createUserInfoData(true);

    if (userInfo.email) {
        const data = { cartItems: createCRSCartItems(cartItems, partnerSlug) };

        return sendPostEventCRS(CRS_ENDPOINT, {
            eventType: EVENT.checkoutPayment,
            resource: RESOURCE + partnerSlug,
            user: {
                ...userInfo,
            },
            data,
        });
    }
    return res400Error;
};

export const trackCheckoutContactsPageCRS = async (cartItems: TCartItem[], partnerSlug: string) => {
    const data = { cartItems: createCRSCartItems(cartItems, partnerSlug) };

    return trackCRS(EVENT.checkoutContacts, data, partnerSlug);
};

export const trackPageView = async (payload?: { path?: string; title?: string }) => {
    const title = window.document?.title;
    const path = window.location?.pathname;
    const data = {
        path: payload?.path || path,
        title: payload?.title || title,
    };

    return trackCRS(EVENT.pageView, data, path);
};

export const trackPurchaseCRS = async (order: TOrderData, partnerSlug: string) => {
    const crsParams = getLS(LS_CRS_UTM) as TCRSParams | undefined;
    const campaignId = (crsParams?.utm_campaign || crsParams?.campaign)?.replace('campaign_', '');

    const payload = {
        total: order.gross_total,
        orderId: order.id,
        promoCode: order.discount?.promo?.code || '',
        promoName: order.discount?.promo?.name || '',
        ...(campaignId && { campaignId }),
        cartItems: createCRSOrderItems(Object.values(order.cart_items), partnerSlug),
    };

    const userInfo = createUserInfoData(true);

    if (userInfo.email) {
        return sendPostEventCRS(CRS_ENDPOINT, {
            eventType: EVENT.purchase,
            resource: RESOURCE + partnerSlug,
            user: {
                ...userInfo,
            },
            data: payload,
        });
    }
    return res400Error;
};
